module.exports = __webpack_public_path__ + "img/icon_strengths_needs.74ae5784.svg";